import { render } from "./SelectAPT.vue?vue&type=template&id=3f5373a0"
import script from "./SelectAPT.vue?vue&type=script&lang=js"
export * from "./SelectAPT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__